<template><section><h1>BackTop</h1>
<blockquote>
<p>回到顶部</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>Slot</h2>
<table>
<thead>
<tr>
<th>名字</th>
<th style="text-align:left">说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>default</td>
<td style="text-align:left"><code>BackTop</code>组件内容</td>
</tr>
</tbody>
</table>
<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>height</td>
<td style="text-align:left">页面滚动高度达到该值时才显示</td>
<td><code>Number</code></td>
<td><code>200</code></td>
</tr>
<tr>
<td>right</td>
<td style="text-align:left">组件距离右边的距离</td>
<td><code>Number</code></td>
<td><code>30</code></td>
</tr>
<tr>
<td>bottom</td>
<td style="text-align:left">组件距离底部的距离</td>
<td><code>Number</code></td>
<td><code>30</code></td>
</tr>
<tr>
<td>time</td>
<td style="text-align:left">滚动的持续时间</td>
<td><code>Number</code></td>
<td><code>500</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/BackTop.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-15.vue?2cab0b23